<template>
  <aha-antd-button
    variant="primary"
    size="lg"
    class="new-presentation-button"
    @click="onNewPresentationButtonClicked"
    v-aha-emit-action
    name="presentation-list-new-presentation-button"
  >
    <aha-icon
      name="plus-new"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      class="mr-2"
    />
    <p>{{ $i18nPresenter.t('New presentation') }}</p>
  </aha-antd-button>
</template>

<script>
export default {
  name: 'NewPresentationButtonV2',

  methods: {
    onNewPresentationButtonClicked() {
      this.$emit('onClickNewPresentation')
    },
  },
}
</script>

<style lang="scss" scoped>
.new-presentation-button {
  @apply text-base font-normal text-gray-0;
  &:deep(.--content-container) {
    @apply flex items-center;
  }
}
</style>
